exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style__FileInputWrapper___rZ4Oi {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  cursor: pointer; }\n\n.style__FileInputButton___Q9ekZ {\n  border: 2px solid gray;\n  color: gray;\n  background-color: white;\n  padding: 8px 20px;\n  border-radius: 8px;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer; }\n\n.style__FileInput___1fA9L {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1; }\n", ""]);

// exports
exports.locals = {
	"FileInputWrapper": "style__FileInputWrapper___rZ4Oi",
	"FileInputButton": "style__FileInputButton___Q9ekZ",
	"FileInput": "style__FileInput___1fA9L"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/FileInput/style.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/component/Forms/FileInput/style.css
// module chunks = 0